import { FiRefreshCw } from "react-icons/fi";

interface DesktopRefreshLabelProps {
  isFetching: boolean;
}

/** 更新状態の文言を常時mountし、取得状態の変化を非layout属性だけで表現する。 */
export function DesktopRefreshLabel({
  isFetching,
}: DesktopRefreshLabelProps): React.ReactElement {
  return (
    <>
      <FiRefreshCw aria-hidden="true" />
      <span className="desktop-toolbar-refresh-label" aria-hidden="true">
        <span data-visible={!isFetching}>更新</span>
        <span data-visible={isFetching}>更新中</span>
      </span>
      <span className="sr-only">
        <span aria-hidden={isFetching}>更新</span>
        <span aria-hidden={!isFetching}>更新中</span>
      </span>
    </>
  );
}
